import React, { createContext } from 'react';
import { TEAM_SETUP_AREAS_UPDATED, TeamSetupAreaLimits, useTeamSetupAreasService } from 'nekst-api';
import { useDataLoaderNew } from 'data-loader';
import { LoadingAnimation } from 'ui-builder';

const TeamSetupAreasLimitReactContext = createContext<{
  limits: TeamSetupAreaLimits
} | null>(null);

export function useTeamSetupAreasLimitContextRequired() {
  const context = React.useContext(TeamSetupAreasLimitReactContext);
  if (!context) {
    throw new Error('useTeamSetupAreasLimitContext must be used within a TeamSetupAreasLimitProvider');
  }
  return context;
}

export function TeamSetupAreasLimitContext(props: {
  children: React.ReactNode,
}) {

  const teamSetupAreasService = useTeamSetupAreasService();

  const { data: limits } = useDataLoaderNew(
    teamSetupAreasService.getLimits,
    {
      events: [TEAM_SETUP_AREAS_UPDATED]
    }
  );

  if (limits) {
    return (
      <TeamSetupAreasLimitReactContext.Provider value={{ limits }}>
        {props.children}
      </TeamSetupAreasLimitReactContext.Provider>
    )
  } else {
    return (<LoadingAnimation />);
  }
}
